import { render, staticRenderFns } from "./publicFocus.module.vue?vue&type=template&id=8c075580&scoped=true"
import script from "./publicFocus.module.vue?vue&type=script&lang=js"
export * from "./publicFocus.module.vue?vue&type=script&lang=js"
import style0 from "./publicFocus.module.vue?vue&type=style&index=0&id=8c075580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c075580",
  null
  
)

export default component.exports